import {IWaitfreeTimeUnit} from './type';
import ICON_THUMBNAIL from '../../public/static/dummy.svg';

export const DEFAULT_THUMBNAIL = ICON_THUMBNAIL;

export const RECENT_ITEM_LOCAL_PREFIX = 'local-';

export const VIEWER_LS_KEY_LAST_PAGE = 'viewer-last-pages';
export const VIEWER_LS_KEY_PROGRESS_RATIO = 'viewer-progress-ratio';
export const LS_KEY_LAST_EPISODE = 'last-episode';

/**
 * iOS 에서 비디오에 가려지는 요소가 있을때 사용한다.
 * CHILD_CN, PARENT_CN 는 (swiper 안에서) 부모 자식 요소에 모두 붙어있어야 동작한다
 */
export const HARDWARE_ACCEL_CN = 'hardwareAccel';
export const HARDWARE_ACCEL_PARENT_CN = 'hardwareAccelParent';
export const HARDWARE_ACCEL_CHILD_CN = 'hardwareAccelChild';

export const WEB_TO_APP_EVENT_PROPS = {
  event_layer: 'web_to_app',
};

export const CONFIRM_BTN_GRADIENT_HEIGHT = '130px';
// 해당 변수의 mb 값은 CONFIRM_BTN_GRADIENT_HEIGHT와 같아야한다.
export const LAST_ELEMENT_MB = 'last:mb-[130px]';

export const CONTENT_TITLE_TOKEN = 'CONTENT_TITLE';

export const IS_PURCHASE_TAB_TOGGLED_LS_KEY = 'is-purchase-tab-toggled';

export const EPISODE_THUMB_RATIO = 76 / 117;

export const TIME_UNIT_TEXT_KEY_MAP: {[key in IWaitfreeTimeUnit]: string} = {
  day: 'contenthome_ticketbar_gidamu',
  hour: 'contenthome_ticketbar_gidamu_hour',
  minute: 'contenthome_ticketbar_gidamu_minute',
};
